// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Components
import { TimeReportRow, BillingRow, ExpenseBillRows } from './billing-table-rows';
import { Table } from 'components/content-containers/tables';


// Component
function BillingTable({ company, ...props }) {
  return (
    <Table className="checkbox-table collapse-table">

      { (!_.isEmpty(company.timeReports) || !_.isEmpty(company.billings)) &&
        <tbody>
          {_.map(company.timeReports, (timeReport) =>
            <TimeReportRow timeReport={timeReport} {...props} key={timeReport.id} />
          )}
          {_.map(company.billings, (billing) =>
            <BillingRow billing={billing} company={company} {...props} key={billing.id} />
          )}
        </tbody>
      }
      {_.map(company.expenseBills, (expenseBill) =>
        <ExpenseBillRows expenseBill={expenseBill} {...props} key={expenseBill.id} />
      )}
    </Table>
  );
}

// Prop types
BillingTable.propTypes = {
  company: PropTypes.object.isRequired
};


export default BillingTable;



// WEBPACK FOOTER //
// ./app/routes/billing/components/billing-table.js